import { render } from "./EntityDetailsDropdown.vue?vue&type=template&id=5d8c11f5&ts=true"
import script from "./EntityDetailsDropdown.vue?vue&type=script&lang=ts"
export * from "./EntityDetailsDropdown.vue?vue&type=script&lang=ts"

import "./EntityDetailsDropdown.vue?vue&type=style&index=0&id=5d8c11f5&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__